import {RESET_ERRORS} from "./types";

export const resetErrors = () => dispatch => {
    dispatch({
        type: RESET_ERRORS
    });
}